<template>
  <section class="lead-activity">
    <div v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
    <div v-else>
      <div class="btn-group-slot w-100">
        <BButtonGroup>
          <!-- <template > -->
            <template v-for="(type, key) in types">
                <BButton
                class="activity-type d-flex"
                type="button"
                :class="{ active: activity.type === key }"
                @click="activity.type = key"
                :index="key"
                v-if="!newIcons[key].hidden"
                >
                  <span class="icon mr-1">
                    <Component
                      :is="newIcons[key].component"
                      :color="activity.type === key ? '#886AF8' : '#242424'"
                      :size="newIcons[key].size"
                    />
                  </span>
                  <span>{{ __(type.name) }}</span>
                </BButton>
            </template>
          <!-- </template> -->
        </BButtonGroup>
      </div>
      <div class="entry activity">
        <div class="media act-media">
          <div class="media-body act-media-body">
            <div class="activity-content" :class="{ 'mb-6px': activity.file }">
              <LeadActivityEdit
                class="form-group form-control activity-edit"
                :activity="activity"
                @input="onInput"
                @transcribing="(value) => isTranscribing = value"
                @isRecordingType="(value) => isRecordingType = value"
                :isTranscriptionEnabled="true"
              >
                <template v-slot:summary>
                  <SummaryEdit 
                    @summaryCreated="setSummary"
                    @discardSummary="discardSummary"
                    :summary="summary"
                    @update:summary="setSummary"
                    @summaryWasEdited="onSummaryWasEdited"
                  />
                </template>
              </LeadActivityEdit>
            </div>
            <div class="form-actions d-flex align-items-center">
              <div
                class="lead-activity-schedule d-flex"
                v-if="activity.type !== 'note'"
              >
                <span class="d-flex align-items-center" v-if="!schedule.active">
                  <button
                    class="btn btn-sm pl-0 mr-2"
                    @click="schedule.active = true"
                  >
                    <i class="fa fa-calendar" />
                    <span>{{ __('Definir agendamento') }}</span>
                  </button>
                </span>
                <span class="d-flex align-items-center" v-if="schedule.active">
                  <span class="mr-2 flex-shrink-0">
                    {{ __('Agendar para') }}
                  </span>
                  <InputDateTimepickerForActivities
                    input-class="form-control date d-inline mr-2"
                    v-model="schedule.date"
                    :users="this.activity.followers.map(f => f.id)"
                    :deal-id="this.deal?.id"
                    :lead-hashid="this.hash"
                  />
                  <span class="mr-2">{{ __('às') }}</span>
                  <InputDateTimepickerForActivities
                    type="time"
                    input-class="form-control time mr-2"
                    v-model="schedule.time"
                    :users="this.activity.followers.map(f => f.id)"
                    :deal-id="this.deal?.id"
                    :lead-hashid="this.hash"
                  />
                  <button
                    class="btn activity-cancel-button btn-sm btn-white text-danger d-inline mr-2"
                    @click="schedule.active = false"
                  >
                    {{ __('Cancelar') }}
                  </button>
                </span>
              </div>
              <div class="status-change d-flex" v-if="availableStatuses.length">
                <span
                  class="d-flex align-items-center"
                  v-if="!statusChange.active"
                >
                  <button
                    class="btn btn-sm btn-white pl-0 mr-2"
                    @click="statusChange.active = true"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewbox="0 0 16 18"
                    >
                      <g>
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M3.798 4.113a6.258 6.258 0 0 1 8.135-.215l-1.862.07a.431.431 0 0 0-.417.45c.01.233.202.416.433.416h.016l2.859-.106a.432.432 0 0 0 .417-.433v-.032-.019l-.106-2.827a.433.433 0 0 0-.866.032l.068 1.773a7.042 7.042 0 0 0-4.129-1.58 7.058 7.058 0 0 0-5.129 1.83 7.12 7.12 0 0 0-2.14 6.959.43.43 0 0 0 .522.317.433.433 0 0 0 .317-.522 6.254 6.254 0 0 1 1.882-6.113z"
                              />
                              <path
                                fill="none"
                                stroke="#3b334a"
                                stroke-miterlimit="50"
                                stroke-width=".7"
                                d="M3.798 4.113a6.258 6.258 0 0 1 8.135-.215l-1.862.07a.431.431 0 0 0-.417.45c.01.233.202.416.433.416h.016l2.859-.106a.432.432 0 0 0 .417-.433v-.032-.019 0l-.106-2.827a.433.433 0 0 0-.866.032l.068 1.773a7.042 7.042 0 0 0-4.129-1.58 7.058 7.058 0 0 0-5.129 1.83 7.12 7.12 0 0 0-2.14 6.959.43.43 0 0 0 .522.317.433.433 0 0 0 .317-.522 6.254 6.254 0 0 1 1.882-6.113z"
                              />
                            </g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M15.026 7.267a.433.433 0 0 0-.522-.317.433.433 0 0 0-.317.522 6.247 6.247 0 0 1-6.072 7.725 6.243 6.243 0 0 1-3.997-1.439l1.885-.17a.432.432 0 1 0-.08-.862l-2.85.256a.432.432 0 0 0-.39.472l.256 2.85c.019.224.208.393.43.393.012 0 .025 0 .038-.003a.432.432 0 0 0 .39-.47l-.153-1.735a7.07 7.07 0 0 0 4.475 1.577 7.075 7.075 0 0 0 4.766-1.84 7.118 7.118 0 0 0 2.141-6.959z"
                              />
                              <path
                                fill="none"
                                stroke="#3b334a"
                                stroke-miterlimit="50"
                                stroke-width=".7"
                                d="M15.026 7.267a.433.433 0 0 0-.522-.317.433.433 0 0 0-.317.522 6.247 6.247 0 0 1-6.072 7.725 6.243 6.243 0 0 1-3.997-1.439l1.885-.17a.432.432 0 1 0-.08-.862l-2.85.256a.432.432 0 0 0-.39.472l.256 2.85c.019.224.208.393.43.393.012 0 .025 0 .038-.003a.432.432 0 0 0 .39-.47l-.153-1.735a7.07 7.07 0 0 0 4.475 1.577 7.075 7.075 0 0 0 4.766-1.84 7.118 7.118 0 0 0 2.141-6.959z"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    {{ __('Alterar status') }}
                  </button>
                </span>
                <span v-if="statusChange.active" class="d-flex">
                  <select
                    v-model="statusChange.selected"
                    class="change-status-select form-control d-inline mr-2"
                  >
                    <option
                      v-for="status in [{
                        id: null,
                        name: __('Selecione um status')
                      }].concat(truncatedStatuses)"
                      :key="status.id"
                      :value="status.id"
                      v-text="__(status.name)"
                    />
                  </select>
                  <button
                    class="btn activity-cancel-button btn-sm btn-white text-danger d-inline mr-2"
                    @click="statusChange.active = false"
                  >
                    {{ __('Cancelar') }}
                  </button>
                </span>
              </div>
              <LeadActivityFollowers
                class="d-flex without-put ml-0"
                v-model="activity.followers"
                btn-custom-class="pl-0 mr-2"
                :active-users="[user]"
              />
              <button v-if="!activity.file" class="btn btn-sm text-decoration-none">
                <span
                  class="d-inline mr-2 text-decoration-underline"
                  @click="activity.file = true"
                >
                  {{ __('Anexar arquivo') }}
                </span>
                <!-- if acitivity.file != null -->
              </button>
              <span class="activity-file-input-container" v-if="activity.file">
                <span class="buttons-container">
                  <label id="activity-file-input-label" for="activity-file-input">
                    Escolher arquivo
                    <input
                      ref="file"
                      type="file"
                      id="activity-file-input"
                      name="activity-file-input"
                      class="d-none"
                      @change="updateActivityFile"
                    />
                  </label>
                  <button
                    class="activity-cancel-button btn btn-sm btn-white text-salesflow-danger d-inline mr-2"
                    @click="removeAttachment"
                  >
                    {{ __('Cancelar') }}
                  </button>
                </span>
                <span
                  v-text="chosenFileName"
                />
              </span>
              <button
                class="salesflow-btn salesflow-btn-primary ml-auto mt-2"
                type="submit"
                :disabled="(!hasStatus && disabled) || isTranscribing || isRecordingType"
                @click="save()"
              >
                <span v-if="saving">
                  <i class="fa fa-circle-o-notch fa-spin" />
                </span>
                <span v-else>{{ __('Salvar') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <span class="clearfix" />
      <BCard v-if="!deal" id="activities-list-tab" no-body>
        <BTabs card>
          <BTab v-if="activities && activities.length && lead" title="Registros" :active="true">
            <BCardText>
              <LeadActivityList
                :activities="activities"
                :lead="lead"
                :deal="deal"
                :user="user"
                :hash="hash"
                :currentPage="currentPage"
                :nextPageUrl="nextPageUrl"
                @input-updated="onInputUpdated"
                @fetch-activities="getActivities"
              />
            </BCardText>
          </BTab>
          <BTab v-if="attendences && attendences.length && lead" title="Syngoo" :active="!(activities && activities.length)">
            <BCardText>
              <LeadAttendences
                :attendences="attendences"
                :lastPage="attendencesLastPage"
                :lead="lead"
              />
            </BCardText>
          </BTab>
        </BTabs>
      </BCard>
      <BCard v-if="deal && activities && activities.length" id="activities-list-tab" no-body>
        <BTabs card>
          <BTab title="Registros">
            <BCardText>
              <LeadActivityList
                :activities="activities"
                :deal="deal"
                :user="user"
                :hash="hash"
                :currentPage="currentPage"
                :nextPageUrl="nextPageUrl"
                @input-updated="onInputUpdated"
                @fetch-activities="getActivities"
              />
            </BCardText>
          </BTab>
        </BTabs>
      </BCard>
      <DeleteActivityModal @confirmActivityDeletion="handleActivityDeletion" />
    </div>
  </section>
</template>

<script>
import { BButtonGroup, BButton, BCard, BTabs, BTab, BCardText } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import Input from '../base/Input.vue';
import InputDateTimepickerForActivities from '../input/DateTimePickerForActivities.vue';
import DeleteActivityModal from '../activity/DeleteActivityModal.vue'
import SummaryEdit from './SummaryEdit.vue';

export default {
  components: {
    BButtonGroup,
    BButton,
    Input,
    BCard,
    BTabs,
    BTab,
    BCardText,
    DeleteActivityModal,
    InputDateTimepickerForActivities,
    SummaryEdit,
  },

  props: ['user', 'deal', 'hash', 'statuses', 'types'],

  data() {
    return {
      inputContent: '',
      activityUpdatedContent: '',
      availableStatuses: [],
      saving: false,
      schedule: {
        active: false,
        date: new Date(),
        time: dayjs().add(30, 'minutes').format('HH:mm'),
      },
      statusChange: {
        active: false,
        selected: null,
      },
      nextPageUrl: '',
      currentPage: '',
      activities: [],
      activityContent: '',
      activity: {
        type: 'note',
        content: '',
        data: '',
        summary: '',
        user: this.user.id,
        followers: [this.user.id],
        scheduled_at: null,
        file: null,
      },
      newIcons: {
        note: { component: 'icon-pencil', size: 15, hidden: false},
        call: { component: 'icon-phone', size: 16, hidden: false},
        email: { component: 'icon-envelope', size: 17, hidden: false},
        visit: { component: 'icon-briefcase', size: 15, hidden: false},
        meeting: { component: 'icon-coffee', size: 17, hidden: false},
        proposal: { component: 'icon-fileText', size: 17, hidden: false},
        whatsapp: { component: 'icon-fileText', size: 17, hidden: true },
      },
      attendences: [],
      attendencesLastPage: null,
      lead: null,
      scheduledActivities: [],
      activityTypes: null,
      summary: '',
      summaryEdition: {
        original: '',
        isEdited: false
      },
      isTranscribing: false,
      isRecordingType: false,
    };
  },

  computed: {
    loading() {
      return this.activity.type === null || this.activities === null;
    },

    chosenFileName () {
      if (typeof this.activity.file === 'object') {
        return this.activity.file.name;
      }

      return 'Nenhum arquivo escolhido.';
    },

    hasStatus() {
      if (this.statusChange.active && this.statusChange.selected) {
        return true;
      }

      return false;
    },

    disabled() {
      if (
        this.activity.type === 'note' &&
        !this.activity.content.replace(/<\/?[^>]+(>|$)/g, '').length && !this.summary
      ) {
        return true;
      }

      return this.saving;
    },

    truncatedStatuses() {
      return this.availableStatuses.map(status => {
        if (status.name.length > 80) {
          return {
            ...status,
            name: status.name.slice(0, 77) + '...'
          };
        }
        return status;
      });
    }
  },

  watch: {
    hash() {
      this.getActivities();
      this.getAttendences();
      this.getLead();
    },

    'schedule.active': function(newValue) {
      if (newValue) {
        this.schedule.time = this.roundToNearest15(new Date());
      }
    },

    'activity.type': function(newType) {
      if (newType === 'note') {
        this.schedule = {
          active: false,
          date: new Date(),
          time: dayjs().add(30, 'minutes').format('HH:mm'),
        };
      }
    },

    types: {
      handler(newTypes) {
        this.activityTypes = newTypes;
      },
      immediate: true,
    },

    summary: {
      handler(newSummary) {
        this.activity.summary = newSummary;
      },
      immediate: true,
    },  
  },

  created() {
    this.getActivities();
    this.getAttendences();
    this.getLead();

    if (typeof this.statuses !== 'undefined') {
      this.availableStatuses = this.statuses;
    }

    Bus.$on(`lead.${this.hash}.activity`, (data) => {
      const index = this.activities.findIndex(activity => !activity.fixed);
      if (index !== -1) {
        this.activities.splice(index, 0, data);
      } else {
        this.activities.push(data);
      }
    });

    Bus.$on(`lead.${this.hash}.activity.complete`, (data) =>
      this.complete(data),
    );

    Bus.$on(`lead.${this.hash}.activity.scheduled`, (data) =>
      this.scheduled(data),
    );

    Echo.channel(`tenant.${this.user.account}`).listen(
      '.activity_created',
      (e) => {
        if (e.activity.lead && this.hash === e.activity.lead.hashid) {
          this.activities.unshift(e.activity);

          Bus.$emit('listHeightUpdate');
        }
      },
    );
  },

  beforeDestroy() {
    Bus.$off(`lead.${this.hash}.update.scheduled`);
  },

  mounted() {
    this.activityTypes = this.types;
  },

  methods: {
    onSummaryWasEdited(editData) {
      this.summaryEdition = editData;
    },

    ifEditedSummarySetSummaryUpdated() {
      
      if (this.summary.trim() != this.summaryEdition.original.trim()) {
        this.activity.summary_updated = true;
        return;
      }
      
      this.activity.summary_updated = false;
    },

    setSummary(summary) {
      this.summary = summary;
      this.checkAndEmit();
    },

    updateActivityFile (event) {
      this.activity.file = event.target.files[0];
      this.$emit('attachments-hasChange', true);
    },

    removeAttachment() {
      this.$set(this.activity, 'file', null);
      this.$emit('attachments-removeChange', true);
    },

    complete(activity) {
      const index = this.activities
        .map((current) => current.id)
        .indexOf(activity.id);

      this.activities.splice(index, 1, activity);
    },

    scheduled(activity) {
      const index = this.activities
        .map((current) => current.id)
        .indexOf(activity.id);

      this.activities.splice(index, 1, activity);
    },

    getActivities() {
      const qs = this.deal ? `?deal=${this.deal.id}` : '';

      this.$http
        .get(`/lead/${this.hash}/activity${qs}`)
        .then(({ data }) => {
          this.activities = data?.data;
          this.currentPage = data?.current_page;
          this.nextPageUrl = data?.next_page_url;
        })
        .catch((error) => {
          console.log(error.responseJSON);
        });
    },

    getAttendences() {
      this.$http.get(`/lead/attendence/${this.hash}`).then(({ body }) => {
        this.attendencesLastPage = body.last_page;
        this.attendences = body.data;
      }).catch(() => {
        Alert.error('Falha ao carregar atendimentos');
      });
    },

    getLead () {
      this.$http.get(`/lead/${this.hash}/json`).then(({ body }) => {
        this.lead = body;
      }).catch((error) => {
        if (error.status === 403) {
          Alert.error(this.__('Sem acesso aos registros no perfil do lead. Verifique suas permissões.'));
        } else {
          Alert.error(this.__('Falha ao carregar dados do lead'));
        }
      });
    },

    save() {
      if (this.hasStatus) {
        this.updateStatus();
      }

      if (this.disabled) {
        return false;
      }

      if (this.summary) {
        this.activity.summary = this.summary;
      }

      const activityContent = this.activity.content;

      if (activityContent.replace(/<\/?[^>]+(>|$)/g, '').length === 0) {
        this.activity.content = '';
      }

      this.saving = true;

      if (this.schedule.active) {
        const formattedDate = dayjs(this.schedule.date).format('YYYY-MM-DD');
        this.activity.scheduled_at = `${formattedDate} ${this.schedule.time}:00`;
      } else {
        this.activity.scheduled_at = null;
      }

      if (this.deal) {
        this.activity.deal_id = this.deal.id;
      }

      if (this.activity.file) {
        // check if file is actually a file
        if (!this.activity.file.name) {
          Alert.error(this.__('Arquivo inválido ou não definido'));
          this.saving = false;
          return false;
        }

        const file = this.$refs.file.files[0];
        const form = new FormData();
        form.append('file', file);

        this.$http
          .post('/file/upload', form)
          .then(({ data: { location } }) => {
            this.activity.file = `${location}`;
            this.saveActivity();
          })
          .catch((error) => {
            Alert.error(
              error.body.file[0] ?? 'Erro ao enviar arquivo, tente novamente',
            );
            this.saving = false;
          });
      } else {
        this.saveActivity();
      }
    },

    saveActivity() {
      if (this.summaryEdition.isEdited) {
        this.ifEditedSummarySetSummaryUpdated();
      }

      this.$http
        .post(`/lead/${this.hash}/activity`, this.activity)
        .then(({ data }) => {
          Bus.$emit(`lead.${this.hash}.activity`, data);
          Bus.$emit('listHeightUpdate');
          Bus.$emit('activityCreated', '');
          this.$emit('activity-changed', '');

          if (data?.scheduled_at) {
            Bus.$emit('activityCreatedWithSchedule');
          }

          this.reset();
        })
        .catch((response) => {
          // try {
          //   this.$http.post('/lead/activity/log', {
          //     activity: this.activity,
          //     user: BulldeskSettings.user,
          //     error: response,
          //   })
          //   .then(() => { console.log('Log registered') })
          //   .catch((error) => { console.error(error); });
          // } catch (error) {
          //   // Ignore
          // }

          if (response.status === 422) {
            if (typeof response.data.scheduled_at[0] !== 'undefined') {
              return Alert.error(response.data.scheduled_at[0]);
            }

            return Alert.error(this.__('Data de agendamento inválida.'));
          }

          Alert.error(this.__('Erro ao salvar atividade. Tente novamente mais tarde.'));
        })
        .finally(() => {
          this.saving = false;
        });
    },

    updateStatus() {
      if (!this.statusChange.active || !this.statusChange.selected) {
        return;
      }

      this.saving = true;

      this.$http
        .put(`/lead/${this.hash}`, { status: this.statusChange.selected })
        .then((response) => {
          Bus.$emit('leadUpdated', response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.saving = false;
          this.statusChange.active = false;
        });
    },

    reset() {
      this.activity = {
        type: 'note',
        content: '',
        data: '',
        user: this.user.id,
        followers: this.activity.followers,
        scheduled_at: null,
        file: null,
      };

      Bus.$emit('closeUsersModal');

      this.schedule = {
        active: false,
        date: new Date(),
        time: dayjs().add(30, 'minutes'),
      };

      this.summaryEdition = {
        original: '',
        isEdited: false
      };

      this.summary = '';

      this.saving = false;
    },

    onInput(content) {
      this.inputContent = content.replace(/<[^>]*>/g, '');
      this.checkAndEmit();
    },

    onInputUpdated(content) {
      this.activityUpdatedContent = content;
      this.checkAndEmit();
    },

    checkAndEmit() {
      if (this.inputContent || this.activityUpdatedContent || this.summary) {
        const contentToEmit = this.inputContent || this.activityUpdatedContent || this.summary;

        this.$emit('activity-changed', contentToEmit);
      } else {
        this.$emit('activity-changed', '');
      }
    },

    handleActivityDeletion({ activity, observation }) {
      this.$http
        .post('/lead/activity/delete', { 
          activity_id: activity.id,
          observation: observation 
        })
        .then(({ data }) => {
          Bus.$emit('closeDropdown');
          Bus.$emit('activity-deleted')
          this.getActivities();
          Alert.success(data.message);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao excluir atividade. Tente novamente mais tarde.'));
        });
    },

    roundToNearest15(date) {
      const d = new Date(date);
      const minutes = d.getMinutes();
      const remainder = minutes % 15;
      const minutesToAdd = remainder === 0 ? 15 : (15 - remainder);
      
      d.setMinutes(minutes + minutesToAdd);
      d.setSeconds(0);
      
      return dayjs(d).format('HH:mm');
    },

    discardSummary() {
      this.summary = '';
      this.activity.summary = '';
      this.checkAndEmit();
    }
  },
};
</script>
<style lang="scss" scoped>
@import '../../../sass/variables';

.activity-cancel-button:hover {
  color: $salesflow-danger-hover !important;
}

.lead-activity {
  .activity-type {
    .icon {
      width: 16px;
      height: 16px;
    }
  }
}

.btn.btn-sm {
  color: $salesflow-font-dark;
  font-size: 0.75rem;
}

input[type='file'] {
  width: 200px;
}

select {
  max-width: 120px;
}

@media (min-width: 1323px) {
  select {
    max-width: 180px;
  }
}

@media (min-width: 1383px) {
  select {
    max-width: 240px;
  }
}

@media (min-width: 1443px) {
  select {
    max-width: 300px;
  }
}

@media (min-width: 1600px) {
  select {
    max-width: 360px;
  }
}

@media (min-width: 1800px) {
  select {
    max-width: 420px;
  }
}

.change-status-select {
  text-overflow: ellipsis;
  padding-right: 24px !important;
}
</style>
